// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_1LM7","has-val":"_liLs","pos-r":"_2xVi","amt-label":"_3HsA","ibl":"_GMxn","tr":"_2U3I","clear":"_GxXr","ib":"_1aDp","custom-check":"_2tdS","c-mark":"_OB75","c-mark-box":"_2STw","amount-inp":"_IzDC","cb":"_3qvR","info":"_3yRx","fix-amt":"_3bI7"};


//////////////////
// WEBPACK FOOTER
// ./form/components/inputs/merchant-amount/style.css
// module id = bsih
// module chunks = 4